<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_xiii"></a><a href="#/xhtml/contents#abb">ABBREVIATIONS</a></p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td>ABS</td>
<td>Archaeology and Biblical Studies</td>
</tr>
<tr>
<td>AGJU</td>
<td>Arbeiten zur Geschichte des antiken Judentums und des Urchristentums</td>
</tr>
<tr>
<td>AOAT</td>
<td>Alter Orient und Altes Testament</td>
</tr>
<tr>
<td>AS</td>
<td>Assyriological Studies</td>
</tr>
<tr>
<td><i>BAR</i></td>
<td><i>Biblical Archaeology Review</i></td>
</tr>
<tr>
<td>BCE</td>
<td>Before the Common Era</td>
</tr>
<tr>
<td>BJS</td>
<td>Brown Judaic Studies</td>
</tr>
<tr>
<td>CE</td>
<td>Common Era</td>
</tr>
<tr>
<td>CHANE</td>
<td>Culture and History of the Ancient Near East</td>
</tr>
<tr>
<td>DJD</td>
<td>Discoveries in the Judaean Desert</td>
</tr>
<tr>
<td>JSOTSup</td>
<td>Journal for the Study of the Old Testament Supplement Series</td>
</tr>
<tr>
<td>LXX</td>
<td>Septuagint</td>
</tr>
<tr>
<td>MC</td>
<td>Mesopotamian Civilizations</td>
</tr>
<tr>
<td>MT</td>
<td>Masoretic Text</td>
</tr>
<tr>
<td>SBLDS</td>
<td>Society of Biblical Literature Dissertation Series</td>
</tr>
<tr>
<td>SBLSBS</td>
<td>Society of Biblical Literature Sources for Biblical Study</td>
</tr>
<tr>
<td>SP</td>
<td>Samaritan Pentateuch</td>
</tr>
<tr>
<td>TSAJ</td>
<td>Texte und Studien zum antiken Judentum</td>
</tr>
<tr>
<td>VTSup</td>
<td>Supplements to Vetus Testamentum</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?5fcdb3ce